<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
  <v-data-table
          no-data-text="Нету модификаторов"
          :headers="headers"
          :items="value"
          :footer-props="footerProps"
          :loading="loading"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :items-per-page="-1"
          loading-text="Загрузка модификаторов... Подождите пожалуйста"
  >
    <template v-slot:item.svg="{ item, index }">
      <div class="category-svg" v-html="item.svg"></div>
    </template>
    <template v-slot:item="{item,index}">
      <tr class="grouped-row">
        <td>
          <template v-if="item.modifiers.length > 0">
            <v-icon class="mr-2" v-if="item.show" @click="item.show = false">mdi-chevron-up</v-icon>
            <v-icon class="mr-2" v-else @click="item.show = true">mdi-chevron-down</v-icon>
          </template>
          <b>{{ item.name }} ({{ item.working_name }})</b>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <v-simple-checkbox @click="toggleMultiple(item)" v-model="item.multiple" :disabled="disabled"></v-simple-checkbox>
        </td>
        <td>
          <v-simple-checkbox @click="toggleCounter(item)" v-model="item.counter" :disabled="disabled"></v-simple-checkbox>
        </td>
        <td>
          <v-simple-checkbox @click="toggleIsRequired(item)" v-model="item.is_required" :disabled="disabled"></v-simple-checkbox>
        </td>
        <td>
          <v-simple-checkbox @click="toggleAsDish(item)" v-model="item.as_dish" :disabled="disabled"></v-simple-checkbox>
        </td>
        <td class="table-input">
          <v-select
                  :items="whereShow"
                  :item-text="where => where.name"
                  :item-value="where => where.value"
                  v-model="item.where_show"
                  dense
                  :disabled="disabled"
                  outlined
                  @change="changeWhereShow(item)"
          ></v-select>
        </td>
        <td class="text-right">
          <v-menu offset-y left :disabled="disabled">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                      small
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="disabled"
              >
                mdi-dots-vertical
              </v-icon>
              <!--<v-btn outlined-->
                     <!--:disabled="disabled"-->
                     <!--class="pl-0 pr-0"-->
                     <!--min-width="36"-->
                     <!--v-bind="attrs"-->
                     <!--v-on="on">-->
                <!--<v-icon>mdi-dots-vertical</v-icon>-->
              <!--</v-btn>-->
            </template>
            <v-list>
              <v-list-item @click.stop="editModifierGroup(item)">
                <v-list-item-title>Редактировать</v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="orderDialog = true; currentModificator = JSON.parse(JSON.stringify(item))">
                <v-list-item-title>Изменить порядок ингредиентов</v-list-item-title>
              </v-list-item>
              <v-list-item @click="editModifiersInGroup(item)">
                <v-list-item-title>Изменить ингредиенты</v-list-item-title>
              </v-list-item>
              <v-list-item @click="submitDialog = true; submitItem = item">
                <v-list-item-title>Удалить</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
      </tr>
      <template v-if="item.modifiers.length > 0">
        <tr v-for="modifier in item.modifiers" v-if="item.show">
          <td>
            <div style="display: flex; align-items: center;">
              <v-simple-checkbox v-if="forProduct" @click="toggleModifierEnabled(item, modifier)" :value="isModifierEnabled(item, modifier)"></v-simple-checkbox>
              {{ modifier.name }}
            </div>
          </td>
          <td>
            <v-text-field outlined
                          v-model="modifier.pivot.price"
                          dense
                          :disabled="disabled"
                          width="100"
                          hide-details
                          style="width: 90px"
                          @change="updatePrice(modifier)"
                          suffix="UAH">
            </v-text-field>
          </td>
          <td>
            <v-text-field outlined
                          v-model="modifier.pivot.weight"
                          dense
                          :disabled="disabled"
                          width="100"
                          hide-details
                          style="width: 90px"
                          @change="updateWeight(modifier)"
                          suffix="г">
            </v-text-field>
          </td>
          <td>
            <v-text-field outlined
                          v-model="modifier.pivot.iiko_id"
                          dense
                          :disabled="disabled"
                          width="100"
                          hide-details
                          style="width: 180px"
                          @change="updateIikoId(modifier)">
            </v-text-field>
          </td>
          <td>
            <v-simple-checkbox @click="changeHide(item, modifier)" v-model="modifier.pivot.is_hide" :disabled="disabled"></v-simple-checkbox>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </template>
    </template>
  </v-data-table>
    <v-dialog
        v-model="orderDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Сортировка
        </v-card-title>
        <v-card-text>
          <draggable
              v-if="currentModificator && currentModificator.id"
              :list="currentModificator.modifiers"
              tag="ul"
              class="order-list"
          >
            <li v-for="item in currentModificator.modifiers"><v-icon>mdi-arrow-all</v-icon> {{ item.name }} </li>
          </draggable>
        </v-card-text>
        <v-card-actions>
          <v-btn
              @click="saveOrder">
            Сохранить
          </v-btn>
          <v-btn
              outlined
              @click="orderDialog = false; currentModificator = {}"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-dialog
          v-model="submitDialog"
          max-width="444"
  >
    <v-card>
      <v-card-title >
        Подтвердить действие
      </v-card-title>

      <v-card-actions>
        <v-btn
                v-if="submitItem == null"
                @click="submitDelete(submitItem); submitDialog = false">
          Да
        </v-btn>
        <v-btn
                v-else
                @click="submitDelete(submitItem); submitDialog = false">
          Да
        </v-btn>
        <v-btn
                outlined
                @click="submitDialog = false"
        >
          Нет
        </v-btn>


      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
    // @ is an alias to /src


    import ModifierService from "../api/ModifierService";
    import draggable  from 'vuedraggable'
    import ProductService from "@/api/ProductService";

    export default {
        name: 'ModifiersGroupTable',
        props: {
            value: Array,
            loading: Boolean,
            disabled: Boolean,
            forProduct: {
              default: false,
              type: Boolean
            },
        },
      components: {draggable},
        data() {
            return {
              currentModificator: {},
              orderDialog: false,
              modifiersGroup: this.value,
              submitDialog: false,
              submitItem: null,
                footerProps: {
                    itemsPerPageText: 'Модификаторов на страницу',
                    pageText: '',
                    itemsPerPageAllText: 'Все',
                    itemsPerPageOptions: [-1]
                },
                whereShow: [
                    {
                        id: 1,
                        name: 'Везде',
                        value: 'all'
                    },
                    {
                        id: 2,
                        name: 'Конструктор',
                        value: 'constructor'
                    },
                    {
                        id: 3,
                        name: 'Карточка',
                        value: 'page'
                    }
                ],
                headers: [
                    {
                        text: 'Ингредиенты',
                        sortable: false,
                    },
                    {
                        text: 'Цена',
                        sortable: false,
                    },
                    {
                        text: 'Вес',
                        sortable: false,
                    },
                    {
                        text: 'Iiko ID',
                        sortable: false,
                    },
                    {
                      text: 'Выключить',
                      sortable: false,
                    },
                    {
                        text: 'Мультивибор',
                        sortable: false,
                    },
                    {
                        text: 'Счётчик',
                        sortable: false,
                    },
                    {
                      text: 'Обязательный',
                      sortable: false,
                    },
                    {
                        text: 'В Iiko как блюдо',
                        sortable: false,
                    },
                    {
                        text: 'Отображать',
                        sortable: false,
                        width: 200
                    },
                    {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
                ],
            }
        },
        mounted() {
        },
        watch: {
          orderDialog() {
            if(!this.orderDialog){
              this.currentModificator = {}
            }
          }
        },
        methods: {
          toggleModifierEnabled(modifierGroup, modifier){
            let enabledModifiers = modifierGroup.pivot.enabled_modifiers ? modifierGroup.pivot.enabled_modifiers.split(',') : []
            if(enabledModifiers.includes(modifier.id.toString())){
              enabledModifiers.splice(enabledModifiers.indexOf(modifier.id.toString()), 1)
            } else {
              enabledModifiers.push(modifier.id.toString());
            }
            modifierGroup.pivot.enabled_modifiers = enabledModifiers.join(',');
            const params = {
              modifierGroupId: modifierGroup.id,
              enabledModifiers: modifierGroup.pivot.enabled_modifiers
            }
            ProductService.updateProductModifiersEnabled(modifierGroup.pivot.products_id, params)
          },
          isModifierEnabled(modifierGroup, modifier){
            let enabledModifiers = modifierGroup.pivot.enabled_modifiers ? modifierGroup.pivot.enabled_modifiers.split(',') : []
            if(enabledModifiers.includes(modifier.id.toString())){
              return true
            }
            return false
          },
          saveOrder(){
            this.loading = true
            const modifiers = [];
            let i = 0;
            this.currentModificator.modifiers.forEach((val) => {
              modifiers.push({id: val.id, order: i})
              i++
            })

            const params ={
              id: this.currentModificator.id,
              modifiers: modifiers
            }

            ModifierService.updateSortInModifierGroup(params).then(response => {
              this.value.find(mod => mod.id == this.currentModificator.id).modifiers = this.currentModificator.modifiers
              this.loading = false
              this.orderDialog = false
              this.currentModificator = {}
            })
          },
          submitDelete(item = null){
            if(item){
              this.remove(item)
            } else {
              // this.massDelete()
            }
          },
          remove(item){
            this.loading = true
            ModifierService.removeModifierGroup(item.id).then(response => {
              this.loading = false
              this.onDeleteModifierGroup()
            })
          },
            updatePrice(item){
              ModifierService.updateModifiersGroupConstructor(item.pivot.id, {price: item.pivot.price})
            },
            updateWeight(item){
              ModifierService.updateModifiersGroupConstructor(item.pivot.id, {weight: item.pivot.weight})
            },
            changeHide(modifierGroup, item){
              const params ={
                modifiers_group_id: modifierGroup.id,
                modifiers_id: item.id
              }
              ModifierService.toggleModifierHide(params)
            },
            updateIikoId(item){
                ModifierService.updateModifiersGroupConstructor(item.pivot.id, {iiko_id: item.pivot.iiko_id})
            },
            editModifierGroup(item) {
                this.$emit('editModifierGroup', item)
            },
            onDeleteModifierGroup(item) {
              this.$emit('onDeleteModifierGroup')
            },
            editModifiersInGroup(item) {
                this.$emit('editModifiersInGroup', item)
            },
            toggleMultiple(item){
                ModifierService.updateModifierGroup({
                  id: item.id,
                  multiple: item.multiple ? 1 : 0
                })
            },
            toggleCounter(item){
              ModifierService.updateModifierGroup({
                id: item.id,
                counter: item.counter ? 1 : 0
              })
            },
            toggleIsRequired(item){
              ModifierService.updateModifierGroup({
                id: item.id,
                is_required: item.is_required ? 1 : 0
              })
            },
            toggleAsDish(item){
                ModifierService.updateModifierGroup({
                    id: item.id,
                    as_dish: item.as_dish ? 1 : 0
                })
            },
            changeWhereShow(item){
              ModifierService.updateModifierGroup({
                id: item.id,
                where_show: item.where_show
              })
            }
        }
    }
</script>

<style lang="scss">
  .category-svg{
    svg{
      width: 37px;
      height: 37px;
      path{
        stroke: #000
      }
    }
  }
  .grouped-row{
    background: #FAFCFF;
  }

</style>

<style lang="scss">
  .order-list{
      li{
        display: block;
      }
  }
  .grouped-row {
    background: #FAFCFF;
  }

  .table-input {
    .v-input {
      height: 40px;
    }
  }
</style>
<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
